export const FETCH_TREASURY_ACCOUNTS = "FETCH_TREASURY_ACCOUNTS";
export const SET_TREASURY_ACCOUNTS = "SET_TREASURY_ACCOUNTS";
export const SET_INVOICE_TO_RELATE = "SET_INVOICE_TO_RELATE";